module.exports = __webpack_public_path__ + "img/upper_frame_front.5e1382e9.png";